"use client";

var __jsx = React.createElement;
import useAuthModals from "@lib/hooks/use-auth-modals";
import LoginFlow from "@modules/shared/auth-flows/flows/login-flow";
import { MuscleButton } from "@modules/shared/components/buttons";
import { useTranslations } from "next-intl";
import React from "react";
const MuscleLoginButton = _ref => {
  let {
    dataTestId,
    className,
    src
  } = _ref;
  const {
    loginFunction,
    loginModalIsOpen,
    setLoginModalIsOpen
  } = useAuthModals();
  const t = useTranslations("Demos");
  return __jsx(React.Fragment, null, __jsx(MuscleButton, {
    variant: "solidSm",
    className: className,
    onClick: loginFunction,
    dataTestId: dataTestId
  }, t("SIGN_IN"), __jsx("div", {
    className: "w-full h-full max-w-[81px] max-h-[16px]"
  }, __jsx("img", {
    src: src,
    alt: "Logo",
    className: "object-contain"
  }))), __jsx(LoginFlow, {
    isOpen: loginModalIsOpen,
    setIsOpen: setLoginModalIsOpen
  }));
};
export default MuscleLoginButton;